import { defaultTo } from 'lodash';
import { DateTime } from 'luxon';
import {
  HospitalPrescriptionRefillStatusModel,
  IHospitalPrescriptionRefillStatusModel,
} from './HospitalPrescriptionRefillStatusModel';
import { IModel, Model, ModelRecord } from './Model';
import {
  IVisitSalesItemModel,
  VisitSalesItemModel,
} from './VisitSalesItemModel';

export interface IHospitalPrescriptionRefillModel extends IModel {
  hospitalPrescriptionRefillId: number;
  dateFilled: string | undefined;
  hospitalPrescriptionId: number;
  visitSalesItemId: number;
  visitSalesItem: IVisitSalesItemModel;
  hospitalPrescriptionRefillStatusId: number;
  hospitalPrescriptionRefillStatus: IHospitalPrescriptionRefillStatusModel;
  hospitalId: number;
  dateCreated: string | undefined;
}

export class HospitalPrescriptionRefillModel
  extends Model
  implements ModelRecord<IHospitalPrescriptionRefillModel>
{
  hospitalPrescriptionRefillId: number;
  dateFilled: DateTime | undefined;
  hospitalPrescriptionId: number;
  visitSalesItemId: number;
  visitSalesItem: VisitSalesItemModel | undefined;
  hospitalPrescriptionRefillStatusId: number;
  hospitalPrescriptionRefillStatus: HospitalPrescriptionRefillStatusModel;
  hospitalId: number;
  dateCreated: DateTime | undefined;

  constructor(params: Partial<IHospitalPrescriptionRefillModel>) {
    super(params);
    this.hospitalPrescriptionRefillId = defaultTo(
      params.hospitalPrescriptionRefillId,
      0,
    );
    this.dateFilled = params.dateFilled
      ? DateTime.fromISO(params.dateFilled, { zone: 'utc' })
      : undefined;
    this.hospitalPrescriptionId = defaultTo(params.hospitalPrescriptionId, 0);
    this.visitSalesItemId = defaultTo(params.visitSalesItemId, 0);
    this.visitSalesItem = params.visitSalesItem
      ? new VisitSalesItemModel(params.visitSalesItem)
      : undefined;
    this.hospitalPrescriptionRefillStatusId = defaultTo(
      params.hospitalPrescriptionRefillStatusId,
      0,
    );
    this.hospitalPrescriptionRefillStatus =
      new HospitalPrescriptionRefillStatusModel(
        params.hospitalPrescriptionRefillStatus,
      );
    this.hospitalId = defaultTo(params.hospitalId, 0);
    this.dateCreated = params.dateCreated
      ? DateTime.fromISO(params.dateCreated, { zone: 'utc' })
      : undefined;
  }
}
